import React from "react";
import { ConversationsReplyType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import { LogoImage } from "../../../../widget/common/ui/Logo";
import { textCase } from "../../../../service/ui/UI";
import { IconImageAsset } from "../../../../widget/common/ui/Icon";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const iconTypes: Array<string> = ["2", "3", "4", "5", "6", "7", "8"];

export const ConversationReply: React.FC<ConversationsReplyType> = ({
  detail,
}) => {
  const message: React.ReactNode =
    detail?.message_type! === "2"
      ? textCase("photo")
      : detail?.message_type! === "4"
      ? textCase("video")
      : detail?.message_type! === "5"
      ? textCase("location")
      : ["3", "6", "7", "8"].includes(detail?.message_type!)
      ? detail?.decripted_mesage!.split("|").slice(-1)[0]
      : detail?.decripted_mesage!;

  return (
    <div className="conversation-reply bgcolor-grey5 mb-1">
      <div className="font-size-12_14 font-gotham-bold color-black">
        {textCase(detail?.name!)}
      </div>
      <div className=" d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div>
            {iconTypes.includes(detail?.message_type!) &&
              getIcon(detail?.message_type!)}
          </div>
          <div className="font-size-12_14 font-gotham-book color-black pt-1 ellipsis line-1">
            {message}
          </div>
        </div>

        <div>
          {["2"].includes(detail?.message_type!) && (
            <div className="preview ms-2" style={{ border: "5px solid white" }}>
              <LogoImage
                url={detail?.decripted_mesage!.split("|")[1]!}
                size={35}
                name="photo"
                fixedHieght={false}
              />
            </div>
          )}

          {["5"].includes(detail?.message_type!) && (
            <div className=" ms-2">
              <IconImageAsset name="loc_reply_type" size={40} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const getIcon = (type: string): JSX.Element => {
  let icon = <></>,
    name = "doc";
  if (UtilityHelper.isNotEmpty(type) && iconTypes.includes(type)) {
    if (type === "2") {
      name = "camera";
    } else if (type === "3") {
      name = "mic";
    } else if (type === "4") {
      name = "video";
    } else if (type === "5") {
      name = "location";
    }

    icon = (
      <span className="opacity-04 pe-2">
        <IconImageAsset name={name} size={12} />
      </span>
    );
  }

  return icon;
};
